<template>
  <div class="console-panel" :style="{'display': stateStyle}" >
    <div class="console-header">
      <div class="console-modules">
        <span :class="usecaseClass" @click="usecaseClick">测试用例</span>
        <span :class="resultClass" @click="resultClick">代码执行结果</span>
      </div>
      <div class="arrow-down" @click="consoleClose"></div>
    </div>

    <div class="console-body">
      <div class="testcase-input" :style="{'display':usecaseDisplay}">
        <textarea v-model="context" rows="2" wrap="soft"
                  class="textarea-input"></textarea>
      </div>

      <div class="result-context" :style="{'display':resultDisplay}">
        <pre v-html="runResult.msg"></pre>
        <table class="table-box" v-if="recordsSize">
          <tr>
            <td>序号</td>
            <td>内存</td>
            <td>运行时间</td>
            <td>状态</td>
            <td>代码运行结果</td>
          </tr>
          <tr v-for="item in runResult.records" :key="item.recordId">
            <td>{{item.recordId}}</td>
            <td>{{item.MemorySize}}</td>
            <td>{{item.runTime}}</td>
            <td v-if="item.runState"><img src="../../assets/ok.png"></td>
            <td v-else><img src="../../assets/err.png"></td>
            <td class="td-red">{{item.runResult}}</td>
          </tr>
        </table>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "consolePanel",
  props:{
    consoleState: {
      type: Boolean,
      default:false
    },
    runResult:{
      type: Object,
      default:()=>{
        return{
          msg: '暂无执行结果',
          records:[
            {recordId: "1",
            MemorySize: "23kb",
            runTime: "23ms",
            runState: false,
            runResult: '结果错误'
            }
          ]
        }
      }
    }
  },
  data(){
    return{
      context:'',
      moduleAction:'RESULT'
    }
  },
  computed:{
    recordsSize: function (){
      return this.runResult.records.length > 0;
    },
    stateStyle:function (){
      if(this.consoleState){
        return 'block'
      }else{
        return 'none'
      }
    },
    usecaseClass: function (){
      if(this.moduleAction == 'USECASE'){
        return 'module active'
      }else{
        return 'module'
      }
    },
    resultClass: function (){
      if(this.moduleAction == 'RESULT'){
        return 'module active'
      }else{
        return 'module'
      }
    },
    usecaseDisplay: function (){
      if(this.moduleAction == 'USECASE'){
        return 'block'
      }else{
        return 'none'
      }
    },
    resultDisplay: function (){
      if(this.moduleAction == 'RESULT'){
        return 'block'
      }else{
        return 'none'
      }
    }
  },
  methods:{
    usecaseClick: function (){
      this.moduleAction = 'USECASE'
    },
    resultClick: function (){
      this.moduleAction = 'RESULT'
    },
    consoleClose: function (){
      this.$emit('event-console-close')
    },
    getContext:function (){
      return this.context
    }

  }
}
</script>

<style scoped>
.console-panel{
  background: #1e1e1e;
  border-top: 1px solid hsla(0,0%,100%,.15);
  position: relative;
  height:200px;
}
.console-header{
  align-items: center;
  color: #fff;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  padding: 10px 10px;
  height: 35px;
  box-sizing: border-box;
}
.console-modules
{
  float:left;
}

.module {
  opacity: .4;
  padding-bottom: 1px;
  margin-right: 15px;
  cursor: pointer;
}

.module.active {
  border-bottom: 1px solid #fff;
  opacity: 1;
}


.arrow-down
{
  cursor: pointer;
  border-radius:5px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top:  10px solid #fff;
}

.console-body {
  color: hsla(0,0%,100%,.6);
  font-size: 14px;
  height: calc(100% - 35px);
  overflow: auto;
  padding: 5px 10px 5px 5px;
}

.testcase-input, .result-context{
    background:#1e1e1e;
    border-color: hsla(0,0%,100%,.15);
    color: #fff;
    height: calc(100% - 20px);
    resize: none;
    padding: 5px;
}

.textarea-input
{
    background:#1e1e1e;
    border-color: hsla(0,0%,100%,.15);
    color: #fff;
    resize: none;
    width:100%;
    height:100%;
}

.table-box{
  width:100%;
  border-collapse: collapse;
  font-size: 14px;
}
.table-box tr{
  height: 30px;
  text-align: center;
}
.table-box td{
  width: 20%;
}
.table-box td img{
  width: 20px;
  height: 20px;
}

</style>
